<div class="content">

  <!-- Begin dashboard -->
  <div class="container-fluid" style="max-height: 860px;">

    <!-- Page Heading -->
    <div class="row mx-1">
      <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 class="dashboard-title">Roaster Upload</h1>
      </div>

    </div>

 <!-- Content Row -->
    <div class="row align-items-center roaster-toolbar">

      <!-- SEARCH -->
      <div class="col-lg-5 col-md-12 col-sm-12 roaster-search-column">

        <div class="google-search-container">

          <i class="fa fa-search search-icon"></i>

          <input
            (keyup)="handleKeyUp($event)"
            #searchBox
            class="google-search-input"
            type="text"
            placeholder="Search Roaster..."
          />

          <i
            *ngIf="searchBox.value"
            class="fa fa-times clear-icon"
            (click)="clearSearch(searchBox)">
          </i>

        </div>

      </div>


      <!-- OFFICE / DATE / PAYER -->
      <div class="col-lg-5 col-md-12 col-sm-12 roaster-controls-column">

        <!-- OFFICE -->
        <div class="roaster-office-control">

          <select
            class="form-control custom-select roaster-native-select"
            [(ngModel)]="selectedOfficeId"
            (change)="_fetchData()">

            <option value="" disabled>
              Select Office
            </option>

            <option
              *ngFor="let type of OfficeType"
              [value]="type.id">

              {{ type.name }}

            </option>

          </select>

        </div>


        <!-- DATE -->
        <div class="roaster-date-control">

          <input
            type="text"
            id="date"
            class="form-control roaster-date-input"
            placeholder="Date"
            bsDatepicker
            [(ngModel)]="uploadDate"
            [bsConfig]="{
              dateInputFormat: 'MM/DD/YYYY',
              placement: 'bottom',
              containerClass: 'theme-blue'
            }">

        </div>


        <!-- PAYER -->
        <div class="roaster-payer-control">

          <mat-form-field
            appearance="outline"
            class="roaster-payer-select">

            <mat-select
              [(ngModel)]="selectedPayerId"
              placeholder="Select Payer"
              panelClass="select-with-search">

              <!-- Prevent selected value disappearing after search -->
              <mat-select-trigger>
                <span class="roaster-payer-selected-text">
                  {{ getSelectedPayerName(selectedPayerId) }}
                </span>
              </mat-select-trigger>


              <!-- Search -->
              <mat-option class="roaster-payer-search-option">

                <input
                  type="text"
                  matInput
                  placeholder="Search payer"
                  [(ngModel)]="searchPayor"
                  (ngModelChange)="searchPayers()"
                  autocomplete="off"
                  class="dropdown-search-input"
                  (click)="$event.stopPropagation()"
                  (keydown)="$event.stopPropagation()"
                />

              </mat-option>


              <mat-option
                *ngFor="let payer of filterPayerArray; trackBy: trackByFn"
                [value]="payer.id">

                {{ payer.name }}

              </mat-option>

            </mat-select>

          </mat-form-field>

        </div>

      </div>


      <!-- ACTIONS -->
      <div class="col-lg-2 col-md-12 col-sm-12 roaster-actions-column">

        <div class="roaster-action-bar">

          <!-- FILTER -->
          <div
            class="roaster-filter-wrapper"
            #filterDropdown>

            <button
              type="button"
              class="listing-btn listing-btn-secondary listing-filter-btn"
              [class.active]="showMonthFilter"
              (click)="toggleDateFilter()"
              #filterBtn
              title="Filter">

              <i class="fa-solid fa-sliders"></i>

              <span class="listing-btn-label">
                Filters
              </span>

              <span
                *ngIf="selectedMonth"
                class="listing-filter-count">
                1
              </span>

            </button>


            <!-- MONTH FILTER -->
            <div
              *ngIf="showMonthFilter"
              class="roaster-filter-popover"
              (click)="$event.stopPropagation()">

              <!-- HEADER -->
              <div class="roaster-filter-header">

                <div>

                  <div class="roaster-filter-title-row">

                    <span class="roaster-filter-title">
                      Filters
                    </span>

                    <span
                      *ngIf="selectedMonth"
                      class="roaster-filter-active-badge">

                      Active

                    </span>

                  </div>

                  <div class="roaster-filter-subtitle">
                    Filter the Roaster list by month.
                  </div>

                </div>


                <button
                  type="button"
                  class="roaster-filter-close"
                  (click)="toggleDateFilter()">

                  <i class="fa-solid fa-xmark"></i>

                </button>

              </div>


              <!-- BODY -->
              <div class="roaster-filter-body">

                <div class="roaster-filter-section-heading">

                  <span class="roaster-filter-section-icon">
                    <i class="fa-regular fa-calendar"></i>
                  </span>

                  <div>

                    <div class="roaster-filter-section-title">
                      Month
                    </div>

                    <div class="roaster-filter-section-hint">
                      Select the month and year you want to display.
                    </div>

                  </div>

                </div>


                <div class="roaster-filter-field">

                  <label for="monthYear">
                    Month / Year
                  </label>

                  <input
                    type="text"
                    id="monthYear"
                    class="form-control roaster-filter-input"
                    placeholder="MM/YYYY"
                    bsDatepicker
                    [(ngModel)]="selectedMonth"
                    [bsConfig]="{
                      dateInputFormat: 'MM/YYYY',
                      minMode: 'month',
                      showWeekNumbers: false,
                      containerClass: 'theme-blue',
                      adaptivePosition: false
                    }"
                    [maxDate]="todaysDate"
                    (click)="$event.stopPropagation()"
                    (bsValueChange)="onMonthSelected($event)"
                  />

                </div>

              </div>


              <!-- FOOTER -->
              <div class="roaster-filter-footer">

                <button
                  type="button"
                  class="listing-btn listing-btn-secondary"
                  (click)="resetFilter()">

                  <i class="fa-solid fa-rotate-left"></i>
                  Reset

                </button>


                <button
                  type="button"
                  class="listing-btn listing-btn-primary"
                  [disabled]="!selectedMonth"
                  (click)="applyFilter()">

                  <i class="fa-solid fa-check"></i>
                  Apply Filter

                </button>

              </div>

            </div>

          </div>


          <!-- ROASTER UPLOAD -->
          <button
            type="button"
            class="listing-btn listing-btn-primary listing-btn-icon"
            (click)="openModal()"
            title="Roaster Upload"
            [disabled]="!authService.hasRole('client-edit')">

            <i class="fa-solid fa-cloud-arrow-up"></i>

          </button>


          <!-- COUNTER TABLE -->
          <button
            type="button"
            class="listing-btn listing-btn-secondary listing-btn-icon"
            (click)="openTableModal()"
            title="Counter Table"
            [disabled]="!authService.hasRole('client-edit')">

            <i class="fa-solid fa-table-list"></i>

          </button>

        </div>

      </div>



          <div class="col-xl-12 col-md-12 mb-2">
              <div class="table-panel p-4">
                <div class="table-responsive table-scroll-x">
                  <table class="table table-sm" matSort (matSortChange)="sortData($event)">
                    <thead>
                    <tr>
                      <th scope="col">Sr.No</th>
                      <th mat-sort-header="firstName" scope="col">Name</th>
                      <th mat-sort-header="dob" scope="col">DOB</th>
                      <th mat-sort-header="planCode" scope="col">Plan Code</th>
                      <th mat-sort-header="memberId" scope="col">Member Id</th>
                      <th mat-sort-header="providerName" scope="col">Employer Name</th>
                      <th mat-sort-header="groupNumber" scope="col">Group No</th>
                      <th scope="col">Action</th>
                    </tr>
                    </thead>
                    <tbody *ngFor="let table of tableData | filter: searchText; let i = index; trackBy: trackByFn">
                    <tr>
                      <th scope="row">{{i + 1}}</th>
                      <td >{{table.firstName ? table.firstName +' '+ table.lastName : '-'}}</td>
                      <td>{{table.dob ? (table.dob | date: 'MM/dd/yyyy') : '-'}}</td>

                      <td>{{table.planCode ? table.planCode : '-'}}</td>
                      <td>{{table.memberId ? table.memberId : '-'}}</td>
                      <td>{{table.employerName ? table.employerName : '-'}}</td>
                      <td>{{table.groupNumber ? table.groupNumber : '-'}}</td>
                      <td>
                        <a title="Delete" (click)="deleteEntry(table.id)"><i class="fa-regular fa-trash-can text-danger"></i></a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                      </td>
                    </tr>
                    </tbody>
                    <tbody *ngIf="tableData == null || tableData?.length == 0">
                    <tr>
                      <td colspan="6" class="text-center"> No record found !</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div *ngIf="tableData?.length !== 0" class="d-flex justify-content-end mt-3">
                  <mat-paginator
                    [length]="totalRecord"
                    [pageIndex]="pagination.currentPage"
                    [pageSize]="pagination.size"
                    [pageSizeOptions]="[5, 10, 25, 100, 200, 500]"
                    aria-label="Select page"
                    showFirstLastButtons
                    color="warn"
                    (page)="pageChange($event)">
                  </mat-paginator>

                  <mat-form-field appearance="outline" class="page-selector">
                    <mat-label>Go to Page</mat-label>
                    <mat-select [(ngModel)]="pagination.currentPage" (selectionChange)="jumpToPage($event)">
                      <mat-option *ngFor="let page of totalPagesArray" [value]="page - 1">
                        {{ page }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>

    <!-- =====================================================
        ROASTER UPLOAD MODAL
        ===================================================== -->
    <div
      #bulkUpload
      class="modal roaster-modal"
      tabindex="-1"
      role="dialog">

      <div
        class="modal-dialog roaster-upload-dialog"
        role="document">

        <div class="modal-content roaster-modal-content">


          <!-- HEADER -->
          <div class="roaster-modal-header">

            <div class="roaster-modal-heading">

              <div class="roaster-modal-icon">
                <i class="fa-solid fa-cloud-arrow-up"></i>
              </div>

              <div>
                <h3 class="roaster-modal-title">
                  Roaster Upload
                </h3>

                <p class="roaster-modal-subtitle">
                  Upload your roster file for the selected office and payer.
                </p>
              </div>

            </div>


            <button
              type="button"
              class="roaster-modal-close"
              title="Close"
              (click)="closeBulkUploadModal()">

              <i class="fa-solid fa-xmark"></i>

            </button>

          </div>


          <!-- BODY -->
          <div class="roaster-modal-body">

            <form>


              <!-- DROPZONE -->
              <div
                *ngIf="!fileImage"
                class="roaster-upload-zone"
                [class.is-dragover]="isDragOver"
                (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave($event)"
                (drop)="onDrop($event)">

                <input
                  type="file"
                  #fileDropRef
                  id="fileDropRef"
                  (change)="onFilesSelected($event)"
                  accept=".xls,.xlsx,.xlsm,.xlsb,.xltx,.xltm,.csv,.txt,.pdf"
                />


                <div class="roaster-upload-zone-icon">
                  <i class="fa-solid fa-file-arrow-up"></i>
                </div>

                <div class="roaster-upload-zone-title">
                  Drag & drop your file here
                </div>

                <div class="roaster-upload-zone-description">
                  Excel, CSV or PDF files are supported
                </div>


                <label
                  for="fileDropRef"
                  class="listing-btn listing-btn-secondary roaster-browse-btn">

                  <i class="fa-regular fa-folder-open"></i>
                  Browse File

                </label>

              </div>


              <!-- SELECTED FILE -->
              <div
                *ngIf="fileImage"
                class="roaster-selected-file">

                <div class="roaster-file-preview">

                  <img
                    [src]="fileImage"
                    alt="Uploaded File"
                    class="roaster-file-image"
                  />

                </div>


                <div class="roaster-file-info">

                  <div class="roaster-file-label">
                    Selected File
                  </div>

                  <div
                    *ngFor="let file of files"
                    class="roaster-file-name"
                    [title]="file.name">

                    {{ file.name }}

                  </div>

                </div>


                <button
                  type="button"
                  class="roaster-file-remove"
                  title="Remove file"
                  (click)="removeImage()">

                  <i class="fa-solid fa-trash-can"></i>

                </button>

              </div>

            </form>


            <!-- ERROR -->
            <div
              *ngIf="errorMessagePart"
              class="roaster-upload-error">

              <div class="roaster-upload-error-title">

                <i class="fa-solid fa-circle-exclamation"></i>

                {{ errorMessagePart }}

              </div>


              <ul
                *ngIf="errorMessages?.length > 0"
                class="roaster-upload-error-list">

                <li *ngFor="let error of errorMessages">
                  {{ error }}
                </li>

              </ul>

            </div>

          </div>


          <!-- FOOTER -->
          <div class="roaster-modal-footer">

            <button
              type="button"
              class="listing-btn listing-btn-secondary"
              (click)="closeBulkUploadModal()">

              Cancel

            </button>


            <button
              *ngIf="files?.length"
              type="button"
              class="listing-btn listing-btn-primary"
              (click)="uploadFiles()">

              <i class="fa-solid fa-cloud-arrow-up"></i>
              Upload File

            </button>

          </div>

        </div>

      </div>

    </div>

    <!-- =====================================================
        COUNTER TABLE MODAL
        ===================================================== -->
    <div
      #table
      class="modal roaster-modal"
      tabindex="-1"
      role="dialog">

      <div
        class="modal-dialog roaster-table-dialog"
        role="document">

        <div class="modal-content roaster-modal-content">


          <!-- HEADER -->
          <div class="roaster-modal-header">

            <div class="roaster-modal-heading">

              <div class="roaster-modal-icon">
                <i class="fa-solid fa-table-list"></i>
              </div>

              <div>
                <h3 class="roaster-modal-title">
                  Payer Counter
                </h3>

                <p class="roaster-modal-subtitle">
                  Monthly payer-wise roster upload summary.
                </p>
              </div>

            </div>


            <button
              type="button"
              class="roaster-modal-close"
              title="Close"
              (click)="closeTableModal()">

              <i class="fa-solid fa-xmark"></i>

            </button>

          </div>


          <!-- BODY -->
          <div class="roaster-modal-body roaster-table-modal-body">

            <div class="roaster-counter-table-wrapper">

              <table
                class="table table-sm roaster-counter-table"
                matSort
                (matSortChange)="sortPayerTable($event)">

                <thead>
                  <tr>

                    <th scope="col">
                      Sr.No
                    </th>

                    <th
                      mat-sort-header="payerName"
                      scope="col">
                      Payer Name
                    </th>

                    <th
                      mat-sort-header="count"
                      scope="col">
                      Count
                    </th>

                    <th
                      mat-sort-header="month"
                      scope="col">
                      Month
                    </th>

                    <th
                      mat-sort-header="year"
                      scope="col">
                      Year
                    </th>

                  </tr>
                </thead>


                <tbody>

                  <tr
                    *ngFor="
                      let row of tablePayerData;
                      let i = index
                    ">

                    <td>
                      {{
                        paginationPayer.currentPage *
                        paginationPayer.size +
                        i +
                        1
                      }}
                    </td>

                    <td>
                      {{
                        row.payerName !== null &&
                        row.payerName !== undefined &&
                        row.payerName !== ''
                          ? row.payerName
                          : '-'
                      }}
                    </td>

                    <td>
                      {{
                        row.count !== null &&
                        row.count !== undefined
                          ? row.count
                          : '-'
                      }}
                    </td>

                    <td>
                      {{
                        row.month !== null &&
                        row.month !== undefined &&
                        row.month !== ''
                          ? row.month
                          : '-'
                      }}
                    </td>

                    <td>
                      {{
                        row.year !== null &&
                        row.year !== undefined &&
                        row.year !== ''
                          ? row.year
                          : '-'
                      }}
                    </td>

                  </tr>

                </tbody>


                <tbody
                  *ngIf="
                    !tablePayerData ||
                    tablePayerData.length === 0
                  ">

                  <tr>

                    <td
                      colspan="5"
                      class="text-center roaster-empty-row">

                      No record found!

                    </td>

                  </tr>

                </tbody>

              </table>

            </div>

          </div>


          <!-- TABLE FOOTER -->
          <div
            *ngIf="tablePayerData?.length !== 0"
            class="roaster-table-footer">

            <mat-paginator
              [length]="totalPayerRecord"
              [pageIndex]="paginationPayer.currentPage"
              [pageSize]="paginationPayer.size"
              [pageSizeOptions]="[5, 10, 25, 100, 200, 500]"
              aria-label="Select payer table page"
              showFirstLastButtons
              color="warn"
              (page)="payerPageChange($event)">
            </mat-paginator>


            <mat-form-field
              appearance="outline"
              class="roaster-page-selector">

              <mat-label>
                Go to Page
              </mat-label>

              <mat-select
                [(ngModel)]="paginationPayer.currentPage"
                (selectionChange)="jumpToPayerPage($event)">

                <mat-option
                  *ngFor="let page of totalPayerPagesArray"
                  [value]="page - 1">

                  {{ page }}

                </mat-option>

              </mat-select>

            </mat-form-field>

          </div>


          <!-- CLOSE FOOTER -->
          <div class="roaster-modal-footer roaster-table-close-footer">

            <button
              type="button"
              class="listing-btn listing-btn-secondary"
              (click)="closeTableModal()">

              Close

            </button>

          </div>

        </div>

      </div>

    </div>
